import { object, string } from "yup"

export const createAccountSchema = object({
  name: string().required("Name is a required field"),
  email: string().email().required("Email is a required field"),
  password: string()
    .min(8, "Password should be at least 8 characters")
    .required("Password is a required field")
})
